/* Newsletter opt-in — see blocks/form-newsletter.liquid */

// Long enough for a slow Iterable response, short enough that a dropped request
// leaves the visitor with a working form rather than a spinner.
const SUBMIT_TIMEOUT = 8000;

// The POST often answers in under 100ms, so the form flips to the thank-you before
// the click registers as having done anything. Hold the loading state for at least
// this long so the submit is visibly acknowledged.
const MIN_LOADING = 700;

class NewsletterOptin extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector("form");
    this.sink = this.querySelector(".form-newsletter__sink");
    this.success = this.querySelector("[data-newsletter-success]");
    this.submit = this.querySelector(".form-newsletter__submit");
    if (!this.form || !this.sink) return;

    this.onSubmit = this.onSubmit.bind(this);
    this.onSettled = this.onSettled.bind(this);
    this.reveal = this.reveal.bind(this);
    this.form.addEventListener("submit", this.onSubmit);
    this.sink.addEventListener("load", this.onSettled);
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
    clearTimeout(this.revealTimer);
    if (this.form) this.form.removeEventListener("submit", this.onSubmit);
    if (this.sink) this.sink.removeEventListener("load", this.onSettled);
  }

  onSubmit() {
    // Only fires once the browser's own validation has passed, so a missing
    // address or an unticked consent box never reaches here.
    this.pending = true;
    this.startedAt = Date.now();
    if (this.submit) this.submit.classList.add("loading");
    this.timer = setTimeout(this.onSettled, SUBMIT_TIMEOUT);
  }

  onSettled() {
    // The sink fires load once when it is first parsed, before any submit.
    if (!this.pending) return;
    this.pending = false;
    clearTimeout(this.timer);
    // Pay out only the remainder, so a slow response is never padded further and
    // the 8s fallback still reveals immediately.
    const remaining = MIN_LOADING - (Date.now() - this.startedAt);
    this.revealTimer = setTimeout(this.reveal, Math.max(0, remaining));
  }

  reveal() {
    if (this.submit) this.submit.classList.remove("loading");
    if (!this.success) return;
    // Iterable answers cross-origin, so a completed POST is the only signal
    // available — a rejected address cannot be told apart from an accepted one.
    this.success.hidden = false;
    this.form.hidden = true;
    this.querySelectorAll("[data-newsletter-hide-on-success]").forEach((el) => {
      el.hidden = true;
    });
  }
}

if (!customElements.get("newsletter-optin")) {
  customElements.define("newsletter-optin", NewsletterOptin);
}
